<template>
  <span class="svg-icon-email">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.9976 19.2502H5.99756C2.34756 19.2502 0.247559 17.1502 0.247559 13.5002V6.50024C0.247559 2.85024 2.34756 0.750244 5.99756 0.750244H15.9976C19.6476 0.750244 21.7476 2.85024 21.7476 6.50024V13.5002C21.7476 17.1502 19.6476 19.2502 15.9976 19.2502ZM5.99756 2.25024C3.13756 2.25024 1.74756 3.64024 1.74756 6.50024V13.5002C1.74756 16.3602 3.13756 17.7502 5.99756 17.7502H15.9976C18.8576 17.7502 20.2476 16.3602 20.2476 13.5002V6.50024C20.2476 3.64024 18.8576 2.25024 15.9976 2.25024H5.99756Z" :fill="color"/>
      <path d="M11.0003 10.8699C10.1603 10.8699 9.31027 10.6099 8.66027 10.0799L5.53026 7.57994C5.21027 7.31994 5.15027 6.84993 5.41027 6.52993C5.67027 6.20993 6.14027 6.14994 6.46027 6.40994L9.59026 8.90994C10.3503 9.51994 11.6403 9.51994 12.4003 8.90994L15.5303 6.40994C15.8503 6.14994 16.3303 6.19993 16.5803 6.52993C16.8403 6.84993 16.7903 7.32994 16.4603 7.57994L13.3303 10.0799C12.6903 10.6099 11.8403 10.8699 11.0003 10.8699Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
